import { Component, h, Prop, Host, Method, Watch, State, Event, getAssetPath } from '@stencil/core'
import type { JSX, EventEmitter } from '@stencil/core'
import '@dotlottie/player-component'
import { statuses, type StatusOptions } from '../../utils/statuses'
import type { DotLottiePlayer } from '@dotlottie/player-component'
import { type IMaglrComponent } from '../../utils/IMaglrComponent'

@Component({
    tag: 'maglr-lottie',
    styleUrl: 'maglr-lottie.scss',
    shadow: true,
    assetsDirs: ['editorSettings', 'lottie-assets'],
})
export class Lottie implements IMaglrComponent {
    player!: DotLottiePlayer // define a variable for html element

    @Prop() autostart: boolean
    @Prop() loop: string
    @Prop() controls: boolean = false
    @Prop() mode: string = 'normal'
    @Prop() src: string = ''
    @Prop() uuid: string
    @State() status: StatusOptions = statuses.BLANK
    manualOverwrite: StatusOptions = statuses.BLANK

    @Event({
        eventName: 'maglr-webcomponent',
        composed: true,
        cancelable: true,
        bubbles: true,
    })
        fireEvent: EventEmitter

    componentDidRender (): void {
        if (this.loop === 'true' || Number(this.loop) > 1) {
            this.player.setAttribute('loop', this.loop) // this.loop === 1 ? 'true' : this.loop)
        }
        // this.player.setAttribute('direction', -1)
    }

    @Method() async start (force = false): Promise<void> {
        if ((force || (this.autostart && this.manualOverwrite !== statuses.PAUSED)) && this.src !== '') {
            if (this.status === statuses.STOPPED || (this.status === statuses.PAUSED && this.player.offsetHeight === 0)) {
                this.parseMyObjectProp(this.src)
            } else {
                this.player.play()
            }
        }
        this.status = statuses.STARTED
    }

    @Method() async pause (): Promise<void> {
        this.player.pause()
        this.status = statuses.PAUSED
    }

    @Method() async stop (): Promise<void> {
        this.player.stop()
        this.status = statuses.STOPPED
    }

    @Method() async seek (value = 0): Promise<void> {
        this.player.seek(`${Math.ceil(value * 100)}%`)
    }

    @Method() async goToScreenshotState (): Promise<void> {}

    @Method() async doAction (action: string): Promise<void> {
        switch (action) {
            case 'start':
            case 'play':
            case 'restart':
                void this.start(true)
                this.manualOverwrite = statuses.STARTED
                break
            case 'pause':
                void this.pause()
                this.manualOverwrite = statuses.PAUSED
                break
        }
    }

    // async setSpeed (speed: number): Promise<void> {
    //     this.player.setSpeed(speed)
    // }
    //
    // async seek (percentage: string): Promise<void> {
    //     this.player.seek(percentage)
    // }

    @Watch('src')
    parseMyObjectProp (newValue: string): void {
        if (this.hasSource(newValue)) {
            void this.player.load(newValue).then(() => {
                this.player.play()
            })
        }
    }

    @Watch('status')
    watchPropHandler (status: number): void {
        this.fireEvent.emit({
            uuid: this.uuid,
            type: 'status',
            status,
        })
    }

    hasSource (src): boolean {
        return src !== '' && src !== 'false'
    }

    componentWillLoad (): void {
        this.status = statuses.LOADED
    }

    componentDidLoad (): void {
        this.player.addEventListener('ready', () => {
            if (this.status === statuses.STARTED) {
                void this.start()
            }
        }, { once: true })
    }

    render (): JSX.Element {
        return (
            <Host>
                { this.hasSource(this.src)
                    ? <dotlottie-player
                        ref={(el) => { this.player = el as DotLottiePlayer }}
                        autoplay={false}
                        controls={this.controls}
                        src={this.src}
                        style={{ height: '100%', width: '100%' }}
                    ></dotlottie-player>
                    : <div class='placeholder' style={{ backgroundImage: `url(${getAssetPath('./lottie-assets/thumb.svg')}` }}></div>
                }
            </Host>
        )
    }
}
